import { Component, OnInit, EventEmitter } from '@angular/core';
import { DCInput } from './includes/dynamic_components/dynamic.service';

@Component({
    selector: 'demo-mesasge',
    templateUrl: 'demo-message.component.html',
    styleUrls: ['demo-message.component.css'],
})

export class DemoMessageComponent implements OnInit, DCInput {
    title = "Внимание!";
    destroyEmitter:EventEmitter<null> = new EventEmitter();
    constructor() { }

    ngOnInit() { }

    close(){
        this.destroyEmitter.emit(null);
    }
}